// news.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const useNewsStore = defineStore('news', {
    state: () => ({
        newsList: []
    }),
    actions: {
        async getNews(filter) {
            try {
                const response = await axios.get('/news', { params: filter })
                if (response.status === 200 && filter.paginate > 0) {
                    this.newsList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getNewById(id) {
            try {
                const response = await axios.get(`/new/${id}`)
                if (response.status === 200) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createNew(body) {
            try {
                const response = await axios.post('/new', body)
                if (response.status === 201) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateNew(id, body) {
            try {
                const response = await axios.post(`/new/${id}`, body)
                if (response.status === 200) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteNew(id) {
            try {
                const response = await axios.delete(`/new/${id}`)
                if (response.status === 200) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        }
    }
})
